import { CreateVerificationCodeDto, ZendeskAuthenticateUserResponseDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher/parse-utils';
export const createZendeskClient = ({ getUnauthenticatedFetcher, getGlobalFetcher, }) => {
    return new ZendeskClientImpl(getUnauthenticatedFetcher, getGlobalFetcher);
};
export class ZendeskClientImpl {
    getUnauthenticatedFetcher;
    getGlobalFetcher;
    constructor(getUnauthenticatedFetcher, getGlobalFetcher) {
        this.getUnauthenticatedFetcher = getUnauthenticatedFetcher;
        this.getGlobalFetcher = getGlobalFetcher;
    }
    /**
     * NOTE: This will be called in the begining of the flow
     *       The user will create the verification code from the client
     *       Then using the code will construct the url
     *       Upon using the url the WebClient will be triggered
     *       Which will send a request to the WebService using the verification code inside the url
     *       Which in return will send an access token to verify ourselves in front of Zendesk
     */
    createVerificationCode() {
        return this.getGlobalFetcher().post(['idp', 'zendesk', 'code'], {
            parser: parserFromDto(CreateVerificationCodeDto),
        });
    }
    generateJwtUnauthenticated(userId, code) {
        return this.getUnauthenticatedFetcher().post(['idp', 'zendesk', 'auth', userId], {
            queryParams: { code },
            parser: parserFromDto(ZendeskAuthenticateUserResponseDto),
        });
    }
    generateJwtAuthenticated() {
        return this.getGlobalFetcher().post(['idp', 'zendesk', 'auth'], {
            parser: parserFromDto(ZendeskAuthenticateUserResponseDto),
        });
    }
}
